import axiosInstance from "../api/axiosInstance";
import { COMPANIES } from "../constants/API_URLs";

export const getCompanies = (params: any): Promise<any> => {
  return axiosInstance.get(COMPANIES, { params });
};

export const getCompany = (id: string): Promise<any> => {
  return axiosInstance.get(`${COMPANIES}/${id}`);
};
